// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__actvE"};